import { SvgIcon } from '@mui/material';
import { FunctionComponent } from 'react';

import Icons from '@Constants/Icons.constants';

import { StyledChip } from './Chip.styles';
import { ChipProps } from './Chip.types';

export const Chip: FunctionComponent<ChipProps> = (
  props: ChipProps
): JSX.Element => {
  const { selected, children, ...resProps } = props;
  return (
    <StyledChip selected={selected} {...resProps}>
      {selected && (
        /** If the chip is selected we want to show a done icon here */
        <SvgIcon>{Icons.done}</SvgIcon>
      )}
      {children}
    </StyledChip>
  );
};

export default Chip;
